import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/data";
import { Reveal } from "@/components/effects/Reveal";

export const ServicesOverview = () => {
  return (
    <section data-testid="services-overview" className="relative py-28 sm:py-36 bg-[#050507]">
      <div className="absolute inset-x-0 top-0 glow-line-mag opacity-50" />
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <Reveal>
              <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">
                — Services
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] max-w-2xl">
                <span className="text-chrome">A full visual</span>{" "}
                <span className="italic text-magcyan">studio</span>
                <br />
                <span className="text-chrome">under one roof.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={240}>
            <p className="max-w-md text-white/55 font-body leading-relaxed">
              From action-charged sports to luxury weddings and corporate
              storytelling — we cover the full spectrum of premium event
              photography and motion.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Camera;
            return (
              <Reveal key={s.title} delay={i * 60}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full glass chrome-border rounded-md p-6 lift overflow-hidden"
                >
                  <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"
                    style={{ background: "radial-gradient(circle, rgba(255,46,147,0.25), transparent 70%)" }}
                  />
                  <div className="absolute -bottom-12 -left-12 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"
                    style={{ background: "radial-gradient(circle, rgba(24,211,255,0.22), transparent 70%)" }}
                  />

                  <div className="relative">
                    <div className="w-11 h-11 rounded-full flex items-center justify-center mb-5 chrome-border bg-black/40">
                      <Icon className="w-4.5 h-4.5 text-white" />
                    </div>
                    <h3 className="font-display text-2xl text-chrome leading-tight mb-2">{s.title}</h3>
                    <p className="text-sm text-white/55 font-body leading-relaxed">{s.desc}</p>

                    <div className="mt-6 inline-flex items-center gap-2 text-[10px] tracking-luxe uppercase text-white/40 group-hover:text-white transition-colors">
                      Explore
                      <span className="w-6 h-px bg-gradient-to-r from-[#ff2e93] to-[#18d3ff]" />
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
